import { render, staticRenderFns } from "./newdeposit.vue?vue&type=template&id=4c4e04aa&scoped=true&"
import script from "./newdeposit.vue?vue&type=script&lang=js&"
export * from "./newdeposit.vue?vue&type=script&lang=js&"
import style0 from "./newdeposit.vue?vue&type=style&index=0&id=4c4e04aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4e04aa",
  null
  
)

export default component.exports